/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DocsIndexRouteImport } from './routes/docs/index'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as DocsPricingRouteImport } from './routes/docs/pricing'
import { Route as DocsGettingStartedRouteImport } from './routes/docs/getting-started'
import { Route as DocsFaqRouteImport } from './routes/docs/faq'
import { Route as AuthLogoutRouteImport } from './routes/auth/logout'
import { Route as AuthLoginRouteImport } from './routes/auth/login'
import { Route as AuthCallbackRouteImport } from './routes/auth/callback'
import { Route as DashboardSettingsIndexRouteImport } from './routes/dashboard/settings/index'
import { Route as DashboardPlaygroundIndexRouteImport } from './routes/dashboard/playground/index'
import { Route as DashboardBillingIndexRouteImport } from './routes/dashboard/billing/index'
import { Route as DashboardApiKeysIndexRouteImport } from './routes/dashboard/api-keys/index'
import { Route as DashboardSettingsTeamRouteImport } from './routes/dashboard/settings/team'
import { Route as DashboardBillingInvoicesRouteImport } from './routes/dashboard/billing/invoices'
import { Route as DashboardApiKeysNewRouteImport } from './routes/dashboard/api-keys/new'
import { Route as DashboardApiKeysKeyIdRouteImport } from './routes/dashboard/api-keys/$keyId'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DocsIndexRoute = DocsIndexRouteImport.update({
  id: '/docs/',
  path: '/docs/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => rootRouteImport,
} as any)
const DocsPricingRoute = DocsPricingRouteImport.update({
  id: '/docs/pricing',
  path: '/docs/pricing',
  getParentRoute: () => rootRouteImport,
} as any)
const DocsGettingStartedRoute = DocsGettingStartedRouteImport.update({
  id: '/docs/getting-started',
  path: '/docs/getting-started',
  getParentRoute: () => rootRouteImport,
} as any)
const DocsFaqRoute = DocsFaqRouteImport.update({
  id: '/docs/faq',
  path: '/docs/faq',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLogoutRoute = AuthLogoutRouteImport.update({
  id: '/auth/logout',
  path: '/auth/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/auth/login',
  path: '/auth/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardSettingsIndexRoute = DashboardSettingsIndexRouteImport.update({
  id: '/dashboard/settings/',
  path: '/dashboard/settings/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardPlaygroundIndexRoute =
  DashboardPlaygroundIndexRouteImport.update({
    id: '/dashboard/playground/',
    path: '/dashboard/playground/',
    getParentRoute: () => rootRouteImport,
  } as any)
const DashboardBillingIndexRoute = DashboardBillingIndexRouteImport.update({
  id: '/dashboard/billing/',
  path: '/dashboard/billing/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardApiKeysIndexRoute = DashboardApiKeysIndexRouteImport.update({
  id: '/dashboard/api-keys/',
  path: '/dashboard/api-keys/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardSettingsTeamRoute = DashboardSettingsTeamRouteImport.update({
  id: '/dashboard/settings/team',
  path: '/dashboard/settings/team',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardBillingInvoicesRoute =
  DashboardBillingInvoicesRouteImport.update({
    id: '/dashboard/billing/invoices',
    path: '/dashboard/billing/invoices',
    getParentRoute: () => rootRouteImport,
  } as any)
const DashboardApiKeysNewRoute = DashboardApiKeysNewRouteImport.update({
  id: '/dashboard/api-keys/new',
  path: '/dashboard/api-keys/new',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardApiKeysKeyIdRoute = DashboardApiKeysKeyIdRouteImport.update({
  id: '/dashboard/api-keys/$keyId',
  path: '/dashboard/api-keys/$keyId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/logout': typeof AuthLogoutRoute
  '/docs/faq': typeof DocsFaqRoute
  '/docs/getting-started': typeof DocsGettingStartedRoute
  '/docs/pricing': typeof DocsPricingRoute
  '/dashboard': typeof DashboardIndexRoute
  '/docs': typeof DocsIndexRoute
  '/dashboard/api-keys/$keyId': typeof DashboardApiKeysKeyIdRoute
  '/dashboard/api-keys/new': typeof DashboardApiKeysNewRoute
  '/dashboard/billing/invoices': typeof DashboardBillingInvoicesRoute
  '/dashboard/settings/team': typeof DashboardSettingsTeamRoute
  '/dashboard/api-keys': typeof DashboardApiKeysIndexRoute
  '/dashboard/billing': typeof DashboardBillingIndexRoute
  '/dashboard/playground': typeof DashboardPlaygroundIndexRoute
  '/dashboard/settings': typeof DashboardSettingsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/logout': typeof AuthLogoutRoute
  '/docs/faq': typeof DocsFaqRoute
  '/docs/getting-started': typeof DocsGettingStartedRoute
  '/docs/pricing': typeof DocsPricingRoute
  '/dashboard': typeof DashboardIndexRoute
  '/docs': typeof DocsIndexRoute
  '/dashboard/api-keys/$keyId': typeof DashboardApiKeysKeyIdRoute
  '/dashboard/api-keys/new': typeof DashboardApiKeysNewRoute
  '/dashboard/billing/invoices': typeof DashboardBillingInvoicesRoute
  '/dashboard/settings/team': typeof DashboardSettingsTeamRoute
  '/dashboard/api-keys': typeof DashboardApiKeysIndexRoute
  '/dashboard/billing': typeof DashboardBillingIndexRoute
  '/dashboard/playground': typeof DashboardPlaygroundIndexRoute
  '/dashboard/settings': typeof DashboardSettingsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/logout': typeof AuthLogoutRoute
  '/docs/faq': typeof DocsFaqRoute
  '/docs/getting-started': typeof DocsGettingStartedRoute
  '/docs/pricing': typeof DocsPricingRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/docs/': typeof DocsIndexRoute
  '/dashboard/api-keys/$keyId': typeof DashboardApiKeysKeyIdRoute
  '/dashboard/api-keys/new': typeof DashboardApiKeysNewRoute
  '/dashboard/billing/invoices': typeof DashboardBillingInvoicesRoute
  '/dashboard/settings/team': typeof DashboardSettingsTeamRoute
  '/dashboard/api-keys/': typeof DashboardApiKeysIndexRoute
  '/dashboard/billing/': typeof DashboardBillingIndexRoute
  '/dashboard/playground/': typeof DashboardPlaygroundIndexRoute
  '/dashboard/settings/': typeof DashboardSettingsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/auth/callback'
    | '/auth/login'
    | '/auth/logout'
    | '/docs/faq'
    | '/docs/getting-started'
    | '/docs/pricing'
    | '/dashboard'
    | '/docs'
    | '/dashboard/api-keys/$keyId'
    | '/dashboard/api-keys/new'
    | '/dashboard/billing/invoices'
    | '/dashboard/settings/team'
    | '/dashboard/api-keys'
    | '/dashboard/billing'
    | '/dashboard/playground'
    | '/dashboard/settings'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/auth/callback'
    | '/auth/login'
    | '/auth/logout'
    | '/docs/faq'
    | '/docs/getting-started'
    | '/docs/pricing'
    | '/dashboard'
    | '/docs'
    | '/dashboard/api-keys/$keyId'
    | '/dashboard/api-keys/new'
    | '/dashboard/billing/invoices'
    | '/dashboard/settings/team'
    | '/dashboard/api-keys'
    | '/dashboard/billing'
    | '/dashboard/playground'
    | '/dashboard/settings'
  id:
    | '__root__'
    | '/'
    | '/login'
    | '/auth/callback'
    | '/auth/login'
    | '/auth/logout'
    | '/docs/faq'
    | '/docs/getting-started'
    | '/docs/pricing'
    | '/dashboard/'
    | '/docs/'
    | '/dashboard/api-keys/$keyId'
    | '/dashboard/api-keys/new'
    | '/dashboard/billing/invoices'
    | '/dashboard/settings/team'
    | '/dashboard/api-keys/'
    | '/dashboard/billing/'
    | '/dashboard/playground/'
    | '/dashboard/settings/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LoginRoute: typeof LoginRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthLogoutRoute: typeof AuthLogoutRoute
  DocsFaqRoute: typeof DocsFaqRoute
  DocsGettingStartedRoute: typeof DocsGettingStartedRoute
  DocsPricingRoute: typeof DocsPricingRoute
  DashboardIndexRoute: typeof DashboardIndexRoute
  DocsIndexRoute: typeof DocsIndexRoute
  DashboardApiKeysKeyIdRoute: typeof DashboardApiKeysKeyIdRoute
  DashboardApiKeysNewRoute: typeof DashboardApiKeysNewRoute
  DashboardBillingInvoicesRoute: typeof DashboardBillingInvoicesRoute
  DashboardSettingsTeamRoute: typeof DashboardSettingsTeamRoute
  DashboardApiKeysIndexRoute: typeof DashboardApiKeysIndexRoute
  DashboardBillingIndexRoute: typeof DashboardBillingIndexRoute
  DashboardPlaygroundIndexRoute: typeof DashboardPlaygroundIndexRoute
  DashboardSettingsIndexRoute: typeof DashboardSettingsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/docs/': {
      id: '/docs/'
      path: '/docs'
      fullPath: '/docs'
      preLoaderRoute: typeof DocsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/docs/pricing': {
      id: '/docs/pricing'
      path: '/docs/pricing'
      fullPath: '/docs/pricing'
      preLoaderRoute: typeof DocsPricingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/docs/getting-started': {
      id: '/docs/getting-started'
      path: '/docs/getting-started'
      fullPath: '/docs/getting-started'
      preLoaderRoute: typeof DocsGettingStartedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/docs/faq': {
      id: '/docs/faq'
      path: '/docs/faq'
      fullPath: '/docs/faq'
      preLoaderRoute: typeof DocsFaqRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/logout': {
      id: '/auth/logout'
      path: '/auth/logout'
      fullPath: '/auth/logout'
      preLoaderRoute: typeof AuthLogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/auth/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/settings/': {
      id: '/dashboard/settings/'
      path: '/dashboard/settings'
      fullPath: '/dashboard/settings'
      preLoaderRoute: typeof DashboardSettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/playground/': {
      id: '/dashboard/playground/'
      path: '/dashboard/playground'
      fullPath: '/dashboard/playground'
      preLoaderRoute: typeof DashboardPlaygroundIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/billing/': {
      id: '/dashboard/billing/'
      path: '/dashboard/billing'
      fullPath: '/dashboard/billing'
      preLoaderRoute: typeof DashboardBillingIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/api-keys/': {
      id: '/dashboard/api-keys/'
      path: '/dashboard/api-keys'
      fullPath: '/dashboard/api-keys'
      preLoaderRoute: typeof DashboardApiKeysIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/settings/team': {
      id: '/dashboard/settings/team'
      path: '/dashboard/settings/team'
      fullPath: '/dashboard/settings/team'
      preLoaderRoute: typeof DashboardSettingsTeamRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/billing/invoices': {
      id: '/dashboard/billing/invoices'
      path: '/dashboard/billing/invoices'
      fullPath: '/dashboard/billing/invoices'
      preLoaderRoute: typeof DashboardBillingInvoicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/api-keys/new': {
      id: '/dashboard/api-keys/new'
      path: '/dashboard/api-keys/new'
      fullPath: '/dashboard/api-keys/new'
      preLoaderRoute: typeof DashboardApiKeysNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/api-keys/$keyId': {
      id: '/dashboard/api-keys/$keyId'
      path: '/dashboard/api-keys/$keyId'
      fullPath: '/dashboard/api-keys/$keyId'
      preLoaderRoute: typeof DashboardApiKeysKeyIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LoginRoute: LoginRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthLogoutRoute: AuthLogoutRoute,
  DocsFaqRoute: DocsFaqRoute,
  DocsGettingStartedRoute: DocsGettingStartedRoute,
  DocsPricingRoute: DocsPricingRoute,
  DashboardIndexRoute: DashboardIndexRoute,
  DocsIndexRoute: DocsIndexRoute,
  DashboardApiKeysKeyIdRoute: DashboardApiKeysKeyIdRoute,
  DashboardApiKeysNewRoute: DashboardApiKeysNewRoute,
  DashboardBillingInvoicesRoute: DashboardBillingInvoicesRoute,
  DashboardSettingsTeamRoute: DashboardSettingsTeamRoute,
  DashboardApiKeysIndexRoute: DashboardApiKeysIndexRoute,
  DashboardBillingIndexRoute: DashboardBillingIndexRoute,
  DashboardPlaygroundIndexRoute: DashboardPlaygroundIndexRoute,
  DashboardSettingsIndexRoute: DashboardSettingsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
